import { useSite } from "@/context/SiteContext";

/** Single compact explanation of the process — replaces the old "What you receive" / "What happens next" pair. */
export default function ProcessSteps() {
  const { config, content, openAudit, openLead } = useSite();
  const steps = [
    {
      num: "01",
      title: "Upload your bill",
      text: "One recent bill, or up to 12 months. PDF or a clear phone photo. Extra details are optional — the form takes about a minute.",
    },
    {
      num: "02",
      title: "We review it",
      text: "The project team reads your bill manually: usage, demand charges, sizing assumptions, potential benefits and payback. Unclear numbers get flagged, never guessed.",
    },
    {
      num: "03",
      title: "Discuss your options",
      text: "We follow up by phone or email with next steps and a timeline. Then you decide — ownership, financing or storage — at your pace.",
    },
  ];
  return (
    <section className="section process" id="process" data-testid="process-steps">
      <div className="wrap">
        <div className="section-heading">
          <div>
            <span className="eyebrow">HOW IT WORKS</span>
            <h2>
              Three steps.
              <br />
              No pressure.
            </h2>
          </div>
          <p>{content.responseTimeNote || content.followUpNote || "We'll confirm the next steps and review timeline after receiving your bill."}</p>
        </div>
        <div className="process-grid">
          {steps.map((s) => (
            <article className="process-card" key={s.num} data-testid={`process-step-${s.num}`}>
              <span className="process-num">{s.num}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </article>
          ))}
        </div>
        <div className="process-actions">
          <button className="btn" data-testid="process-upload" onClick={() => openAudit()}>
            Upload my electric bill <span>↗</span>
          </button>
          <button className="btn light" data-testid="process-callback" onClick={() => openLead("contact", "Callback request")}>
            Request a callback <span>↗</span>
          </button>
          <a className="btn light" href={config.phoneHref} data-testid="process-phone">
            Call {config.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
